import { Button } from "antd";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useDeleteModal } from "../../../../hooks/useDeleteModal";
import { withRouter } from "../../../../utilities/withRouter";

const ImageRemover = (props) => {
  const { data, imageId, pageRef, setRefreshFlag, setLoading, imageLoading } = props;
  const { formatMessage } = useIntl();
  const params = useParams();

  const deleteModal = useDeleteModal({
    headingText: formatMessage({ id: "delete" }),
    refreshTrigger: () => {
      setRefreshFlag(true);
    },
    pageRef,
    actionText: formatMessage({ id: "delete" }),
  });

  const handleDeleteIntent = () => {
    const URL = `/v1/${params.sport}/o/${data.organizationId}/images/${imageId}`;
    deleteModal.setData.setUrl(URL);
    deleteModal.setData.setTextContent(formatMessage({ id: "delete.item.confirm" }));
    deleteModal.visibility.open();
  };

  useEffect(() => {
    setLoading(deleteModal.deleteLoading);
  }, [setLoading, deleteModal.deleteLoading]);

  return (
    <>
      {deleteModal.element()}
      {!imageLoading && (
        <Button
          className="image-remover-btn"
          size="small"
          shape="circle"
          type="danger"
          icon={<i className="fas fa-times" />}
          onClick={handleDeleteIntent}
          loading={deleteModal.deleteLoading}
        />
      )}
    </>
  );
};

export default withRouter(ImageRemover);
